<!-- <svelete:window bind:clientWidth={width}/> -->

<script>
    import './css/normalize.css';
    import './css/sets.css';
    import Carousel from 'svelte-carousel'
import { onMount } from 'svelte';
    // export let width=920;
    let width=920
    let height=517
    let autoplay=true;


    // export let height = 400;


    const links = [
        231056602, // france 17
        97038344,//tallship mast
        181268012, // france 16
        103550633,// dance avec france 14
        178884266, // france 16 teaser
        136854823, // france 15 
        87403915,//slack
        176161171, //lefkada
        127366326,// yuwake
        97614129,// gibraltar
        105237162,//hsr
    ]

    var monitor = setInterval(function(){
    var elem = document.activeElement;
    if(elem && elem.tagName == 'IFRAME'){
      autoplay=false  
      clearInterval(monitor);
        // alert('clicked!');
    }
}, 1000);




$: console.log('autolay',autoplay)
  </script>
  

  <Carousel
  let:showPrevPage
  let:showNextPage
  autoplay={autoplay}
  autoplayDuration={5000}
  autoplayProgressVisible
  pauseOnFocus
>
 


  <!-- {#if width} -->
  {#each links as url}
  <iframe src="https://player.vimeo.com/video/{url}?byline=0&amp;portrait=0&amp;api=1&autopause=0" width="{width}" height="{height}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>
  {/each}
  <!-- {/if} -->


</Carousel>


  
  <style>

  
 iframe{
      margin: 0;
        /* clear:both; */
        /* height:auto; */
        padding:0;
        /* max-width: 700!important;
        max-height: 700!important; */
        /* background-color: #111; */
    }
  
  
  </style>
  